import { useEffect, useState } from "react";
import { CustomFieldOption } from "../../../api/models/CustomField";
import { ClioRoleField } from "./clioFieldNames";
import { fetchClioCustomFieldOptions } from "./clioSelectApi";

export function useClioCustomFieldOptions(field: ClioRoleField) {
  const [options, setOptions] = useState<CustomFieldOption[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchClioCustomFieldOptions(field).then((next) => {
      if (!cancelled) {
        setOptions(next);
        setLoading(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [field]);

  return { options, loading };
}
